import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterTextBoxHandler from "./IDataFilterTextBoxHandler";

export default class DataFilterTextBoxHandler implements IDataFilterTextBoxHandler {

    setDescriptorValuesFromUrlParams(descriptor: IDataFilterDescriptor, urlParams: URLSearchParams): void {
        descriptor.value = urlParams.get(descriptor.name);
    }

    setDescriptorValuesToUrlParams(descriptor: IDataFilterDescriptor, urlParams: URLSearchParams): void {
        if(descriptor.value) {
            urlParams.set(descriptor.name, descriptor.value);            
        } else {
            urlParams.delete(descriptor.name);
        }
    }
}